import cx from 'classnames';
import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';

interface IndicationListProps {
  indicationFormat: any;
  indicationInfo: any;
  indicationSeqList: any;
  indication: {
    value: {
      // id: number;
      id: string;
      seq: string;
      color: string;
    };
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  onChooseIndicationPart: (data: {}) => void;
}

function IndicationList({
  indicationFormat,
  indicationInfo,
  indicationSeqList,
  indication,
  onChooseIndicationPart,
}: IndicationListProps) {
  return (
    <StyledIndicationList>
      <div className="indicationList__title">
        <CustomText fontSize={20} fontWeight={500}>
          <T>PROJECT_INDICATION</T>
        </CustomText>
      </div>
      <div className="indicationList__container">
        {!!indicationSeqList?.length &&
          indicationSeqList.map((groupItem: any, groupIdx: number) => {
            const isCustom = groupItem.seq === 8;
            {
              return (
                <div className="indicationList__box" key={groupIdx}>
                  {groupItem.list.map((partItem: any, partIdx: number) => {
                    const exceptPartList = ['17', '18'];
                    const selectDisabled = exceptPartList.includes(partItem.seq);
                    // if (exceptPartList.includes(partItem.seq)) return;
                    const isEqualPart = indication.value.seq === partItem.seq;
                    const currentPartItemColor =
                      indicationInfo?.partList.find(
                        (indicationPart: any) => indicationPart.idx === partItem.seq,
                      )?.color || color.blue;

                    // console.log('currentPartItemColor', currentPartItemColor);
                    const versionMarkList = ['6', '21'];
                    const partListLastIdx = groupItem.list.length;
                    const divideLastIdx = partListLastIdx % 3;
                    const noBorderBottomIdxList = Array.from({
                      length: 3,
                    }).map((_, idx) => partListLastIdx - idx);
                    const currentIdx = partIdx + 1;
                    let isNoBorderBottom = null;
                    if (divideLastIdx === 0 && noBorderBottomIdxList.includes(currentIdx)) {
                      isNoBorderBottom = true;
                    } else if (noBorderBottomIdxList.slice(0, divideLastIdx).includes(currentIdx)) {
                      isNoBorderBottom = true;
                    }

                    return (
                      <button
                        onClick={() =>
                          onChooseIndicationPart({
                            groupSeq: groupItem.seq,
                            partSeq: partItem.seq,
                            partAlias: partItem.alias,
                          })
                        }
                        className={cx('indicationList__item', { on: isEqualPart })}
                        key={partIdx}
                      >
                        <StyledCircle color={currentPartItemColor} />
                        <CustomSpan
                          style={{ flexGrow: 1, textAlign: 'left' }}
                          fontColor={'#444'}
                          fontSize={14}
                          fontWeight={400}
                        >
                          {/* {partItem?.name} */}
                          {partItem?.seq?.substring(0, 2) !== 'CI' ? (
                            <T>{`INDICATION_${partItem?.alias}`}</T>
                          ) : (
                            partItem?.name
                          )}
                        </CustomSpan>
                      </button>
                    );
                  })}
                </div>
              );
            }
          })}
      </div>
    </StyledIndicationList>
  );
}

const StyledIndicationList = styled.div`
  margin-top: 14px;
  height: calc(100% - 53px);
  display: flex;
  flex-direction: column;
  .indicationList__title {
    margin-bottom: 20px;
  }
  .indicationList__container {
    display: flex;
    flex-direction: column;
    row-gap: 23px;
    height: 100%;
    flex-grow: 1;
    overflow: auto;

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    .indicationList__box {
      display: flex;
      flex-wrap: wrap;
      .indicationList__item {
        width: 200px;
        height: 64px;
        display: flex;
        padding: 10px 16px;
        column-gap: 14px;
        align-items: center;
        border: 1px solid #e6e6e6;
        &.on {
          border: 2px solid #00a6e2;
        }
      }
    }
  }
`;

const StyledCircle = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${({ color }) => color && `${color}`};
  flex-shrink: 0;
`;

export default IndicationList;
